export { default as appleStore } from "./apple_store.svg";
export { default as facebook } from "./facebook.png";
export { default as facebook2x } from "./facebook@2x.png";
export { default as googlePlay } from "./google_play.svg";
export { default as instagram } from "./instagram.png";
export { default as instagram2x } from "./instagram@2x.png";
export { default as skyline } from "./skyline.svg";
export { default as twitter } from "./twitter.png";
export { default as twitter2x } from "./twitter@2x.png";
